import React, { useEffect, useState } from 'react';
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend,
    ArcElement
} from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';
import annotationPlugin from 'chartjs-plugin-annotation';
import { Bar } from 'react-chartjs-2';
import staticInformationService from '../../../services/Internal/Staff/dashboardInformation.service';

function DashboardChartLicenseStatus() {
    const [licenseStatuses, setLicenseStatuses] = useState();
    const [hasLoaded, setHasLoaded] = useState(false);
    ChartJS.register(
        ArcElement,
        CategoryScale,
        LinearScale,
        BarElement,
        Title,
        Tooltip,
        Legend,
        annotationPlugin
    );
    const dataSummarizer = {
        id: 'dataSummarizer',
        beforeUpdate: chart => {
            let totals = {}
            let highestPoint = 0
            chart.data.datasets.forEach((dataset, datasetIndex) => {
                if (chart.isDatasetVisible(datasetIndex)) {
                    highestPoint = datasetIndex
                    dataset.data.forEach((value, index) => {
                        totals[index] = (totals[index] || 0) + value
                    })
                }
            })
            chart.$dataSummarizer = {
                totals: totals,
                highestPoint: highestPoint
            }
        }
    }
    const licenseStatusConfig = {
        labels: [],
        options: {
            plugins: {
                legend: {
                    position: 'right'
                },
                title: {
                    display: true,
                    text: 'License Statuses',
                    font: {
                        size: 20,
                        family: 'Arial',
                    },
                },
                datalabels: {
                    anchor: 'end',
                    align: 'top',
                    formatter: (value, ctx) => {
                        const total = ctx.chart.$dataSummarizer.totals[ctx.dataIndex]
                        const formatter = new Intl.NumberFormat('en-US');
                        const formattedNumber = formatter.format(total);
                        return formattedNumber;
                    },
                    display: function (ctx) {
                        return ctx.datasetIndex === ctx.chart.$dataSummarizer.highestPoint
                    },
                    font: {
                        size: 16,
                        weight: 'bold',
                        family: 'Arial',
                        style: 'normal'
                    },
                }
            },
            responsive: true,
            scales: {
                x: {
                    stacked: true,
                },
                y: {
                    stacked: true,
                },
            },
            maintainAspectRatio: false,
        }
    }
    useEffect(() => {
        Promise.all([
            staticInformationService.getDashboardLicenseStatuses(),
            staticInformationService.getDashboardNewlyLicensed()
        ]).then((response) => {
            let licenseStatusesResponse = response[0];
            var licenseStatusLabels = licenseStatusesResponse.data.map((x) => x.licenseTypePrefix);
            setLicenseStatuses({
                labels: licenseStatusLabels,
                datasets: [
                    {
                        label: 'Active',
                        data: licenseStatusesResponse.data.map((x) => x.activeCount),
                        backgroundColor: '#117df8',
                    },
                    {
                        label: 'Inactive',
                        data: licenseStatusesResponse.data.map((x) => x.inactiveCount),
                        backgroundColor: '#9870ef',
                    },
                    {
                        label: 'Retired',
                        data: licenseStatusesResponse.data.map((x) => x.retiredCount),
                        backgroundColor: '#d85fd8',
                    },
                    {
                        label: 'Retired Waiver',
                        data: licenseStatusesResponse.data.map((x) => x.retiredWaiverCount),
                        backgroundColor: '#ff52b5',
                    },
                    {
                        label: 'Expired (Non-Deceased)',
                        data: licenseStatusesResponse.data.map((x) => x.expiredNonDeceasedCount),
                        backgroundColor: '#ff548c',
                    },
                    {
                        label: 'Deceased',
                        data: licenseStatusesResponse.data.map((x) => x.expiredDeceasedCount),
                        backgroundColor: '#ff6963',
                    },
                    {
                        label: 'Revoked',
                        data: licenseStatusesResponse.data.map((x) => x.revokedCount),
                        backgroundColor: '#ff873a',
                    },
                    {
                        label: 'Suspended',
                        data: licenseStatusesResponse.data.map((x) => x.suspendedCount),
                        backgroundColor: '#ffa600',
                    }
                ]
            });
            setHasLoaded(true);
        })
    }, [])

    return (
        hasLoaded &&
        <Bar data={licenseStatuses} options={licenseStatusConfig.options} plugins={[ChartDataLabels, dataSummarizer]} />
            )
}

export default DashboardChartLicenseStatus;